export default class Customer {
  static fromJSON(json) {
    return new Customer({
      crowd: json.crowd,
      rewardsNumber: json.rewardsNumber,
      points: json.points,
      tier: json.tier,
      firstName: json.firstName,
      nextTier: json.nextTier,
      programType: json.programType,
      profileType: json.profileType,
      isTravelAgent: json.isTravelAgent,
      tierInfo: json.tierInfo,
      loyaltyNumberR4u: json?.r4uData?.loyaltyNumberR4u,
      iataNumberR4u: json?.travelAgent?.branch?.iata,
      promotionCode: json.companyData?.companyId,
      user: {
        crowd: json.crowd,
        rewardsNumber: json.rewardsNumber,
        tier: json.tier,
        pcrLevel: json?.r4uData?.pcrLevel,
        memberType: json.memberTypeExtended?.code
      }
    })
  }

  static anonymous() {
    return new Customer({})
  }

  constructor({
    crowd,
    rewardsNumber,
    points,
    tier,
    firstName,
    nextTier,
    programType,
    profileType,
    isTravelAgent,
    tierInfo,
    loyaltyNumberR4u,
    iataNumberR4u,
    promotionCode,
    user
  }) {
    this.crowd = crowd || null
    this.rewardsNumber = rewardsNumber || null
    this.points = points || 0
    this.tier = tier || null
    this.isAnonymous = !this.rewardsNumber && !this.tier
    this.isLogged = !this.isAnonymous
    this.firstName = firstName
    this.nextTier = nextTier
    this.programType = programType
    this.profileType = profileType
    this.isTravelAgent = isTravelAgent
    this.tierInfo = tierInfo
    this.promotionCode = promotionCode || null
    this.user = user
    this.loyaltyNumberR4u = loyaltyNumberR4u || null
    this.iataNumberR4u = iataNumberR4u || null
  }

  canBook(stay) {
    return (
      this.isLogged &&
      (stay.isOnlyCash() ||
        (stay.points.hasPoints() && this.points >= stay.points.totalAmountForAllNights))
    )
  }
}
